module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-8"
  }, [_c('div', {
    staticClass: "card card-default widget animated"
  }, [_c('div', {
    staticClass: "card-heading"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditing),
      expression: "!isEditing"
    }],
    staticClass: "IntercomViewing"
  }, [_c('div', {
    staticClass: "form-group col-md-5"
  }, [_c('p', {
    staticStyle: {
      "font-size": "35px"
    }
  }, [_vm._v(_vm._s(_vm.intercom.name))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.org['curOrg']['role'] == 99) ? _c('button', {
    staticClass: "btn  btn-default form-group",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("Edit")]) : _vm._e()])]), _vm._v(" "), (_vm.org['curOrg']['role'] == 99) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditing),
      expression: "isEditing"
    }],
    staticClass: "IntercomEditing col-md-5"
  }, [_c('form-text', {
    ref: "name",
    attrs: {
      "styler": "font-size:35px",
      "label": "Name",
      "name": "email",
      "validation": "required"
    },
    model: {
      value: (_vm.intercomEdit.name),
      callback: function($$v) {
        _vm.$set(_vm.intercomEdit, "name", $$v)
      },
      expression: "intercomEdit.name"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn  btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn  btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitEdit
    }
  }, [_vm._v("Submit")])])], 1) : _vm._e()])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c5292b5","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Devices/Intercom/EditIntercom.vue
// module id = 600
// module chunks = 1